import Button from "./basicComponents/button";
import TextInput from "./basicComponents/text-input";
import * as Icons from "../assets/SVGs/index";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    addUsefulLinkGroup,
    editUsefulLinkGroup,
} from "../state-management/actions/useful-link-groups-actions";
import {
    setAlert,
    setAlertContext,
    setAlertSeverity,
} from "../state-management/actions/alerts-actions";
import { setRowStatus } from "../state-management/actions/global-state-actions";

interface Props {
    groupLink: any;
    data: any;
    onDataUpdate: any;
    setServerUpdate: any;
}

export default function GroupLink({
    groupLink,
    data,
    onDataUpdate,
    setServerUpdate,
}: Props) {
    const dispatch = useDispatch();
    const { rowStatus } = useSelector((state: any) => state.globalState);
    const [group_name, setGroupName] = useState("");

    const isEditingAllowed = rowStatus?.status && group_name !== "";

    useEffect(() => {
        if (rowStatus.status) {
            const setData = groupLink.find(
                (item: any) => item._id === rowStatus.id
            );
            if (setData) setGroupName(setData.group_name);
        } else setGroupName("");
    }, [rowStatus.status, groupLink, data, rowStatus.id]);

    const handleAlert = (status: boolean) => {
        if (status) {
            dispatch(setAlert(true));
            dispatch(setAlertSeverity("success"));
            dispatch(setAlertContext(" عملیات با موفقیت تکمیل شد"));
        }
    };

    const handleChange = (e: any) => {
        const { value } = e.target;
        setGroupName(value);
    };

    const handleSubmit = async () => {
        try {
            const response = await addUsefulLinkGroup({ group_name })(dispatch);
            onDataUpdate((prevData: any) => [...prevData, { group_name }]);
            setServerUpdate((prev: any) => !prev);
            console.log(response);
            handleAlert(true);
        } catch (error) {
            console.log(error);
        }
    };

    const handleEdit = async () => {
        const editingData = groupLink.find(
            (item: any) => item._id === rowStatus.id
        );
        try {
            const response = await editUsefulLinkGroup(editingData._id, {
                group_name,
            })(dispatch);
            onDataUpdate((prevData: any) =>
                prevData.map((item: any) =>
                    item._id === editingData._id
                        ? { ...item, group_name }
                        : item
                )
            );
            setServerUpdate((prev: any) => !prev);
            dispatch(setRowStatus("clear id", false));
            console.log(response);
            handleAlert(true);
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <div className="w-full">
            <div className="flex  justify-between gap-x-6  w-full">
                <TextInput
                    name="header"
                    placeholder="عنوان دسته را وارد کنید"
                    label="عنوان لینک های مربوطه"
                    RightIcon={<Icons.TitleIcon className="w-5 h-5" />}
                    value={group_name}
                    onChange={handleChange}
                />

                <Button
                    variant={!isEditingAllowed ? "success" : "edit"}
                    title={!isEditingAllowed ? "ثبت" : "ویرایش"}
                    paddingx="20px"
                    paddingy="6px"
                    onClick={!isEditingAllowed ? handleSubmit : handleEdit}
                />
            </div>
        </div>
    );
}
